import React from 'react';
import {useDevice} from 'hooks';
import Desktop, {Category} from './Desktop';
import Mobile from './Mobile';

type Props = {categories: Category[]};

export default function WorkCategories({categories}: Props) {
  const {isDesktop} = useDevice();

  return isDesktop ? <Desktop categories={categories} /> : <Mobile categories={categories} />;
}
